import { render, staticRenderFns } from "./codeLogin.vue?vue&type=template&id=47c84574&scoped=true&"
import script from "./codeLogin.vue?vue&type=script&lang=js&"
export * from "./codeLogin.vue?vue&type=script&lang=js&"
import style0 from "./codeLogin.vue?vue&type=style&index=0&lang=less&"
import style1 from "./codeLogin.vue?vue&type=style&index=1&id=47c84574&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c84574",
  null
  
)

export default component.exports